import _styled from "@emotion/styled-base";
import { css } from "@emotion/core";
import { Loader } from "react-feather";
import { spin } from "./css";

var LoadingIcon = /*#__PURE__*/_styled(Loader, {
  target: "ekr6ace0"
})( /*#__PURE__*/css("label:base;animation:", spin, " 1.75s infinite linear;"));

LoadingIcon.displayName = "LoadingIcon";
export default LoadingIcon;